import { useEffect } from 'react'
import { ProductDetailsOrderContainer } from '../../product/containers/product-details-order.container'
import { ProductImageOrderContainer } from '../../product/containers/product-image-order.container'
import { Layout } from '../../shared/layouts/layout'
import { useMainStore } from '../../shared/stores/main.store'
import { ModalLoadExcelComponent } from '../components/cart/excel-upload/modal-upload-excel.component'
import { HeaderComponent } from '../components/header/header.component'
import { ModalCompanySelectionComponent } from '../components/shared/company-selection/modal-company-selection.component'
import { OrderTabsComponent } from '../components/shared/order-tabs/order-tabs.component'
import { useOrderForm } from '../hooks/use-order-form.hook'


export function OrderFormPage() {

	const orderFormHook = useOrderForm()

	const {
		orderId,
		typeModal,
		setIsOpenModalSelectCompany,
		handleSelectCompany,
		handleBackPage,
		isOpenModalSelectCompany,
	} = orderFormHook

	const {
		actions: { setIsLoading },
	} = useMainStore()

	useEffect(() => {
		if (orderId) {
			setIsLoading(false)
		} else {
			setIsLoading(true)
		}
	}, [orderId])


	return (

		<Layout
			pageTitle={`Pedido: ${orderId}`}
			handleGoBack={handleBackPage}
			hiddenFotters={true}
		>
			<ModalCompanySelectionComponent
				onClose={() => setIsOpenModalSelectCompany(false)}
				onSelectCompany={handleSelectCompany}
				isOpen={typeModal === 'selectCompany' && isOpenModalSelectCompany}
			/>

			<ProductDetailsOrderContainer />
			<ProductImageOrderContainer />
			<ModalLoadExcelComponent />
			<div className="space-y-2 min-h-screen pb-10">
				<HeaderComponent />
				<OrderTabsComponent {...orderFormHook} />
			</div>
		</Layout>
	)
}
